import { queryOptions, useQuery } from '@tanstack/react-query'
import dayjs from 'dayjs'

import { getIsLoggedIn } from '../../auth/utils/getIsLoggedIn'
import { communityApi } from '../api/communityApi'
import { COMMUNITY_LIFETIME } from '../models/community.constants'
import { getComputedSubscription, type TComputedSubscription } from '../utils/getComputedSubscription'

type TActiveJourneySubscriptionsOptions<T = TComputedSubscription[]> = { select?: (data: TComputedSubscription[]) => T }

export const getActiveJourneySubscriptionsOptions = <T = TComputedSubscription[]>({
  select,
}: TActiveJourneySubscriptionsOptions<T> = {}) =>
  queryOptions({
    queryKey: ['active_journey_subscriptions'],
    queryFn: ({ signal }) =>
      communityApi.getSubscriptions(
        {
          'community.lifetime': [COMMUNITY_LIFETIME.NOVENA, COMMUNITY_LIFETIME.RETREAT],
          toDate: { after: dayjs().subtract(10, 'days').format('YYYY-MM-DD') },
          exists: {
            leftAt: false,
          },
        },
        { signal },
      ),
    select: (subscriptions) => {
      const computedSubscriptions = subscriptions.member.map(getComputedSubscription)
      return (select ? select(computedSubscriptions) : computedSubscriptions) as T
    },
    staleTime: 15 * 1000,
    enabled: getIsLoggedIn(),
  })

export const useActiveJourneySubscriptionsQuery = <T = TComputedSubscription[]>(
  options: TActiveJourneySubscriptionsOptions<T> = {},
) => useQuery(getActiveJourneySubscriptionsOptions<T>(options))
